/********************************************************************** // @@@
START COPYRIGHT @@@ // AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY //
Copyright 2018 - 2019 // Avi Solar Energy Pvt Ltd. // Protected as an
unpublished work. // The computer program listings, specifications and
documentation // herein are the property of Avi Solar Energy Pvt Ltd., or a
third party supplier // and shall not be reproduced, copied, disclosed, or used
in whole or in part for // any reason without the prior express written
permission of Avi Solar Energy Pvt Ltd. // @@@ END COPYRIGHT @@@ // +++ Code
modified on 2019/02/25
**********************************************************************/
<template>
  <div>
    <ProgressBar :visible="dialog" :theme="true" />
    <v-dialog v-model="isQrcode" max-width="460">
      <v-card>
        <v-card-title class="headline text-xs-center">
          {{ $t('Scan QR code to download the app') }}
        </v-card-title>
        <div class="qr--image">
          <img :src="require('../assets/qr-mobile.svg')" alt="qr-image" width="350" />
        </div>
      </v-card>
    </v-dialog>

    <v-app id="login" v-show="hidden">
      <div></div>
      <v-content>
        <div class="bg-img">
          <img src="./../assets/login/solar.jpg" alt="" />
        </div>
        <div class="enerman">
          <v-container text-xs-center>
            <v-layout rpw wrap>
              <v-flex xs12 class="pad-0">
                <v-layout row wrap class="login-box-6">
                  <v-flex flex xs12 sm12 md5 lg5 xl5 class="bg-img col-pad-0 align-self-center">
                    <v-tooltip bottom class="view-more">
                      <template slot="activator">
                        <a href="https://www.enerman.in" target="_blank">
                          <div class="avi-logo">
                            <img class="img" src="./../assets/logo/enerman-etisol_new_dark.svg" alt=""
                              width="170px" height="170px" />
                          </div>
                        </a>
                      </template>
                      <span>enerman.in</span>
                    </v-tooltip>
                  </v-flex>
                  <v-flex flex xs12 sm12 md7 lg7 xl7 class="col-pad-0 align-self-center">
                    <div class="login-inner-form">
                      <div class="details">
                        <h3 class="login-heading">
                          {{ $t('Please login to your account') }}
                        </h3>
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-text-field append-icon="person" :label="$t('Username')" type="email"
                            :rules="[ computedEmailRule, computedEmailRule2 ]" v-model="model.username" :placeholder="$t('Username')"
                            required></v-text-field>
                          <v-text-field :append-icon="
                              show ? 'visibility' : 'visibility_off'
                            " name="password" :label="$t('Password')" :placeholder="$t('Password')" id="password"
                            :type="show ? 'text' : 'password'" :rules="[ computedPasswordRule ]"
                            v-model="model.password" required @keydown.enter="login"
                            @click:append="show = !show">
                          </v-text-field>
                        </v-form>
                        <v-btn class="btn-md btn-theme btn-block" block large color="#0E3F6D"
                          @click.prevent="loginHandler" :disabled="buttonStatus">
                          {{ $t('Login') }}
                        </v-btn>
                        <div class="checkbox clearfix forgot">
                          <v-btn class="btn-secondary" flat color="primary"
                            @click="isQrcode = !isQrcode">
                            {{ $t('Get Mobile App') }}
                          </v-btn>
                        </div>
                        <div class="checkbox clearfix forgot">
                          <v-btn class="btn-secondary" flat color="primary"
                            @click="hidden = !hidden">
                            {{ `${$t('Forgot Password')} ?` }}</v-btn>
                        </div>
                        <div class="checkbox clearfix forgot">
                          <select v-model="selectedLanguage" @change="languageChangeHandler">
                            <option v-for="(item, index) in Languages" :key="index" :value="item.value">
                              {{ item.text }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </v-content>
    </v-app>
    <span>
      <v-app id="login" v-show="!hidden">
        <v-content>
          <div class="bg-img">
            <img src="./../assets/login/solar.jpg" alt="" />
          </div>
          <div class="enerman">
            <v-container text-xs-center>
              <v-layout rpw wrap>
                <v-flex xs12 class="pad-0">
                  <v-layout row wrap class="login-box-6">
                    <v-flex flex xs12 sm12 md5 lg5 xl5 class="bg-img col-pad-0 align-self-center">
                      <v-tooltip bottom class="view-more">
                        <template slot="activator">
                          <a href="https://www.enerman.in" target="_blank">
                            <div class="avi-logo">
                              <img class="img" src="./../assets/logo/enerman-etisol_new_dark.svg" alt=""
                                width="170px" height="170px" />
                            </div>
                          </a>
                        </template>
                        <span>enerman.in</span>
                      </v-tooltip>
                    </v-flex>
                    <v-flex flex xs12 sm12 md7 lg7 xl7 class="col-pad-0 align-self-center">
                      <div class="login-inner-form">
                        <div class="details">
                          <h3 class="login-heading">{{ $t('Forgot Password') }}</h3>
                          <v-text-field :append-icon="icon" :placeholder="label"
                            v-model="model.username" :label="label" type="text" :rules="[ computedEmailRule, computedEmailRule2 ]">
                          </v-text-field>
                          <p v-show="getGeneralState('mailResendTime') > 0">
                            {{ $t('Resend email after 10 mins', { min: timeRemaining }) }}
                          </p>
                          <v-btn class="btn-md btn-theme btn-block" block large color="#0E3F6D"
                            :disabled="!isResendEmail" @click.prevent="emailSendHandler">
                            {{ $t('Get Mail') }}
                          </v-btn>
                          <v-card-actions class="justify-center">
                            <v-btn flat color="primary" @click="hidden = !hidden">
                              {{
                                $t('Back to Login')
                              }}
                            </v-btn>
                          </v-card-actions>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </v-content>
      </v-app>
    </span>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import LoginService from "@/services/login";
import CustomSelect from '@/components/common/CustomSelect'
import { mapGetters, mapActions, mapMutations } from "vuex";
import ProgressBar from "@/components/utility/ProgressBar.vue";
import moment from "moment";


export default {
  components: {
    CustomSelect,
    ProgressBar,
  },
  data: () => ({
    show: false,
    label: "E-mail",
    icon: "email",
    valid: true,
    hidden: true,
    isQrcode: false,
    model: {
      username: "",
      password: "",
    },
    dialog: false,
    buttonStatus: false,
    timeRemaining: null,
    interval: null,
    Languages: [
      {
        text: 'English',
        value: 'en'
      },
      {
        text: 'Français',
        value: 'fr'
      }
    ],
    selectedLanguage: 'en'
  }),
  computed: {
    ...mapGetters([
      "getRules",
      "hasPlantAssigned",
      "getGeneralState",
      "getProgressBar",
    ]),
    isResendEmail() {
      if (
        this.getGeneralState("mailResendTime") == null ||
        this.getGeneralState("mailResendTime") <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    computedEmailRule() {
      if (!!this.model.username) {
        return true
      } else {
        return this.$t("E-mail is required")
      }
    },
    computedEmailRule2() {
      if (
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.model.username
      )) {
        return true
      } else {
        return this.$t("E-mail must be valid")
      }
    },
    computedPasswordRule() {
      if (!!this.model.password) {
        return true
      } else {
        return this.$t("Password is required")
      }
    },
  },
  mounted() {
    if (
      this.$session.has("jwt") &&
      this.hasPlantAssigned &&
      this.getGeneralState("isPasswordUpdateSkip")
    ) {
      this.$router.push({ name: "home" });
    }

    // This will be going even if you refresh the page
    if (!this.isResendEmail) {
      this.resendTimeRemaining();
    }

    this.selectedLanguage = this.getGeneralState('language')
    i18n.locale = this.selectedLanguage
  },
  methods: {
    ...mapActions(["loginAction"]),
    ...mapMutations([
      "SET_JWT_TOKEN",
      "SET_THEME",
      "SET_THEME_VALUE",
      "SET_MAIL_RESEND_TIME",
      "SET_SHOW_SNACKBAR",
      "SET_SNACKBAR_CONTENT",
      "SET_CURRENT_PASSWORD",
      "SET_PASSWORD_UPDATE_SKIP",
      "SET_PASSWORD_CHANGE_STATUS",
      "SET_PASSWORD_RESET_DIFF",
      "SET_LANGUAGE"
    ]),
    resendTimeRemaining() {
      this.interval = setInterval(() => {
        this.SET_MAIL_RESEND_TIME(this.getGeneralState("mailResendTime") - 1);
        let mins = Math.floor(this.getGeneralState("mailResendTime") / 60);
        let seconds = this.getGeneralState("mailResendTime") % 60;
        this.timeRemaining = `${mins}:${seconds}`;
        if (this.getGeneralState("mailResendTime") <= 0) {
          clearInterval(this.interval);
        }
      }, 1000);
    },
    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true);
      this.SET_SNACKBAR_CONTENT(payload);
    },
    async emailSendHandler() {
      if (this.isResendEmail) {
        if (this.model.username === "") {
          this.updateSnackbar({
            icon: "error",
            timeout: 5000,
            header: "",
            message: "Please enter a valid Email",
          });
          return;
        }
        let response = await LoginService.sendResetEmail({
          id: this.model.username,
        });
        
        if (response.status === 200) {
          this.SET_MAIL_RESEND_TIME(2 * 60);
          this.resendTimeRemaining();
          if (response.data.message.isValid) {
            if (response.data.message.attemptTimeRemaining == 0) {
              this.updateSnackbar({
                icon: "success",
                timeout: 5000,
                header: "",
                message: "Please check email for further instructions",
              });
            } else {
              this.updateSnackbar({
                icon: "error",
                timeout: 5000,
                header: "",
                message: `Please try again after ${response.data.message.attemptTimeRemaining} minutes`,
              });
            }
          } else {
            this.updateSnackbar({
              icon: "error",
              timeout: 5000,
              header: "",
              message: "Please enter a valid Email",
            });
          }
        }
      }
    },
    async loginHandler() {
      if (this.$refs.form.validate()) {
        this.dialog = true;
        this.buttonStatus = true;

        const payload = {
          email: this.model.username,
          password: this.model.password,
        };

        this.loginAction(payload)
          .then((response) => {
            this.dialog = false;
            this.buttonStatus = false;
            if (response.status == 206) {
              return
            }
            this.$session.start();
            this.$session.set("jwt", response.data.token);
            this.SET_JWT_TOKEN(response.data.token)
            const expirationDate = moment(
              response.data.updated_on,
              "YYYY-MM-DD HH:mm:ss"
            );
            const currentDate = moment();
            const diff = currentDate.diff(expirationDate, "days");
            this.SET_PASSWORD_RESET_DIFF(diff);
            this.SET_THEME_VALUE(response.data.theme);
            if (diff < 85) {
              if (this.getGeneralState("theme") == "light") {
                this.SET_THEME(false);
              } else {
                this.SET_THEME(true);
              }
              this.SET_PASSWORD_UPDATE_SKIP(true);
              if (this.getGeneralState("showHomeDB")) {
                this.$router.push(
                  `${this.getRules(["rule", "access_config", "home", "path"])}`
                );
              } else {
                this.$router.push(
                  `${this.getRules([
                    "rule",
                    "access_config",
                    "plantOverview",
                    "path",
                  ])}`
                );
              }
            } else {
              const message =
                diff >= 90
                  ? "Your Password has expired! Please change your password!"
                  : `${90 - diff} days before password validity expires!`;
              this.SET_PASSWORD_UPDATE_SKIP(false);
              this.updateSnackbar({
                icon: "warning",
                timeout: 5000,
                header: "",
                message: message,
              });
              this.SET_CURRENT_PASSWORD(this.model.password);
              this.SET_PASSWORD_CHANGE_STATUS("update");
              this.$router.push({ name: "setPassword" });
            }
          })
          .catch((err) => {
            this.buttonStatus = false;
            this.dialog = false;
          });
      } else {
        this.updateSnackbar({
          icon: "error",
          header: "",
          message: "Invalid email",
        });
        this.model.username = ''
        this.dialog = false;
      }
    },
    languageChangeHandler(event) {
      i18n.locale = event.target.value
      this.SET_LANGUAGE(event.target.value)
    }
  },
};
</script>

<style scoped lang="css">
@import url("https://fonts.googleapis.com/css?family=Corben");
@import url("https://fonts.googleapis.com/css?family=Monoton");
@import url("https://fonts.googleapis.com/css?family=Audiowide");

.bg-img {
  position: fixed;
  height: 100%;
  width: 100%;
}

.bg-img > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-attachment: fixed;
  /* opacity: 0.65; */
  overflow: hidden;
}

.enerman {
  background: transparent;
}

.avi-logo {
  margin-bottom: 0px;
}

.forgot {
  text-align: center;
  width: 100%;
}

.login-heading {
  font-size: 1.375rem;
}

.enerman {
  min-width: 100%;
  min-height: 100vh;
  position: relative;
  text-align: center;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}

.enerman .login-inner-form {
  color: #717171;
  text-align: center;
}

.enerman .col-pad-0 {
  padding: 0;
}

.login-box-6 {
  margin: 0 150px 0 200px;
  max-width: 700px;
  border-radius: 10px;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
  background: #fff;
}

.enerman .login-inner-form .details p a {
  margin-left: 3px;
  color: #717171;
}

.align-self-center {
  -ms-flex-item-align: center !important;
  align-self: center !important;
}

.enerman .login-inner-form .details p {
  margin-bottom: 0;
  font-size: 14px;
}

.enerman .login-inner-form .details {
  padding: 30px 60px 30px 0;
}

.enerman .bg-img {
  position: relative;
  background-size: cover;
  width: 100%;
  bottom: 0;
  border-radius: 10px;
  padding: 80px 30px;
  background: #0f3f6f;
  margin: 30px 0;
  left: -60px;
}

.enerman .login-inner-form h3 {
  margin: 0 0 25px;
  font-size: 22px;
  font-weight: 400;
  color: #0e3f6d;
}

.enerman .login-inner-form .form-group {
  margin-bottom: 20px;
}

.enerman .login-inner-form .input-text {
  outline: none;
  width: 100%;
  padding: 10px 20px;
  font-size: 15px;
  outline: 0;
  font-weight: 500;
  color: #717171;
  border-radius: 3px;
  border: 1px solid #dbdbdb;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
}

.btn-md {
  cursor: pointer;
  padding: 10px 50px 8px 50px;
  letter-spacing: 1px;
  font-size: 15px;
  font-weight: 400;
  height: 45px;
  border-radius: 3px;
  text-transform: uppercase;
}

.btn-secondary {
  cursor: pointer;
  padding: 10px;
  font-size: 15px;
  font-weight: 400;
  height: 20px;
  border-radius: 3px;
  text-transform: uppercase;
}

.enerman .bg-img .logo {
  height: 30px;
  margin-bottom: 20px;
}

.enerman .bg-img p {
  font-size: 15px;
  color: #e8e8e8;
  margin-bottom: 30px;
}

.enerman .login-inner-form input[type="checkbox"],
input[type="radio"] {
  margin-right: 3px;
}

.enerman .login-inner-form button:focus {
  outline: none;
  outline: 0 auto -webkit-focus-ring-color;
}

.enerman .login-inner-form .btn-theme.focus,
.btn-theme:focus {
  box-shadow: none;
}

.enerman .login-inner-form .btn-theme {
  background: #1b548c;
  border: none;
  color: #fff;
}

.enerman .login-inner-form .btn-theme:hover {
  background: #194c7d;
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.1);
}

@media (min-width: 1200px) {
  .login-box-6 {
    margin: 0 auto;
  }
}

@media (max-width: 1200px) {
  .login-box-6 {
    margin: 0 70px 0 120px;
  }
}

@media (max-width: 960px) {
  .enerman .bg-img {
    position: relative;
    background-size: cover;
    width: 100%;
    bottom: 0;
    border-radius: 10px;
    background: #0f3f6f;
    padding: 0px 0px;
    margin: -25px 25px;
    left: 0px;
  }
}

@media (max-width: 600px) {
  .v-content {
    padding: 0px 0px 0px !important;
  }

  .enerman .bg-img {
    position: relative;
    background-size: cover;
    width: 100%;
    bottom: 0;
    border-radius: 10px;
    background: #0f3f6f;
    padding: 0px 0px;
    margin: -25px 25px;
    left: 0px;
  }
}

@media (max-width: 992px) {
  .none-992 {
    display: none;
  }

  .login-box-6 {
    margin: 0 auto;
  }

  .enerman .login-inner-form .details {
    padding: 30px;
  }

  .enerman .pad-0 {
    padding: 0;
  }
}

.qr--image {
  text-align: center;
}

</style>

<style scoped>
select {
  display: inline-block;
  font-size: 17px;
  font-weight: normal;
  border-radius: 4px;
  padding: 0px 12px;
  width: 160px;
  height: 30px;
  /* reset */
  margin: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;

  border: 1px solid var(--v-primary-darken1);
  background-image:
    linear-gradient(45deg, transparent 50%, black 50%),
    linear-gradient(135deg, black 50%, transparent 50%);
  background-position: 129px 13px, 134px 13px;
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
}

select:active {
  background-image:
    linear-gradient(45deg, black 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, black 50%);
  background-position: 134px 13px, 129px 13px;
  background-size:
    5px 5px,
    5px 5px;
  background-repeat: no-repeat;
  border-color: none;
  outline: 0;
}

</style>

